import template from './banner.html';
import './banner.less';

class BannerController {
    constructor() {
        'ngInject';
    }

    $onInit() {
    }

}

export const BannerComponent = {
    name: 'mmsBanner',
    component: {
        template: template,
        controller: BannerController,
        bindings: {
            label: '@bannerLabel'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/banner/banner.component.js